import React, { ChangeEvent, FC, HTMLAttributes, useEffect, useRef } from 'react';
import { styled } from 'linaria/react';
import { convertPxToRem, useTypewriter } from '@shared/lib';
import { typographyRemSizes, withTheme } from '@shared/lib/theme';
import { useIsMountedWithRequestAnimationFrame } from '@shared/lib/react';
import { CrossIcon } from '@shared/assets/icons';
interface SearchInputDesktopProps extends Omit<HTMLAttributes<HTMLInputElement>, 'onChange'> {
  value: string;
  onChange: (value: string) => void;
  inputHeight?: number;
  handleClose: () => void;
}
const SearchInputDesktop: FC<SearchInputDesktopProps> = ({
  value,
  onChange,
  inputHeight = 64,
  handleClose,
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const isMounted = useIsMountedWithRequestAnimationFrame();
  const placeholder = useTypewriter(['Steam...', 'Pubg...', 'PlayStation...'], {
    loop: !value
  });
  useEffect(() => {
    if (isMounted) inputRef.current?.focus();
  }, [isMounted]);
  const handleValueChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };
  return <SearchInputWrapper>
      <Input ref={inputRef} isMounted={isMounted} value={value} onChange={handleValueChange} placeholder={placeholder} inputHeight={inputHeight} {...rest} />
      <IconWrapper onClick={handleClose}>
        <CrossIcon />
      </IconWrapper>
    </SearchInputWrapper>;
};
export default SearchInputDesktop;
const SearchInputWrapper = /*#__PURE__*/styled('div')({
  name: "SearchInputWrapper",
  class: "s4epds2",
  propsAsIs: false
});
interface InputProps {
  isMounted: boolean;
  inputHeight: number;
}
const _exp = /*#__PURE__*/() => ({
  isMounted,
  inputHeight
}) => isMounted ? '100%' : `${convertPxToRem(inputHeight)}rem`;
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.accent;
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.typography.family.MTSWide;
const _exp6 = /*#__PURE__*/() => ({
  theme
}) => theme.typography.weight.medium;
const _exp7 = /*#__PURE__*/() => () => typographyRemSizes.size.pS;
const _exp8 = /*#__PURE__*/() => () => typographyRemSizes.lineHeight.pS;
const _exp9 = /*#__PURE__*/() => () => typographyRemSizes.letterSpacing.pS;
const _exp0 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.constant.white_65;
const Input = withTheme(/*#__PURE__*/styled('input')({
  name: "Input",
  class: "ih4an74",
  propsAsIs: false,
  vars: {
    "ih4an74-0": [_exp()],
    "ih4an74-1": [_exp2()],
    "ih4an74-2": [_exp5()],
    "ih4an74-3": [_exp6()],
    "ih4an74-4": [_exp7()],
    "ih4an74-5": [_exp8()],
    "ih4an74-6": [_exp9()],
    "ih4an74-7": [_exp0()]
  }
}));
const IconWrapper = /*#__PURE__*/styled('button')({
  name: "IconWrapper",
  class: "iydxb3a",
  propsAsIs: false
});

require("./SearchInputDesktop.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./SearchInputDesktop.tsx");